import { render, staticRenderFns } from "./KeyboardMain.vue?vue&type=template&id=37210783&scoped=true&"
import script from "./KeyboardMain.vue?vue&type=script&lang=js&"
export * from "./KeyboardMain.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardMain.vue?vue&type=style&index=0&id=37210783&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37210783",
  null
  
)

export default component.exports